import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';

import { GlobalNavigationLineOfBusiness } from '__generated__/api/types';

import { Header as HeaderBernie } from '@gc/global-components';
import { MyList } from './my-list';
import { Qualtrics } from './qualtrics';

export interface HeaderProps {
  className?: string;
}

export const Header: React.FunctionComponent<HeaderProps> = ({ className }) => (
  <HeaderBernie className={className} lineOfBusiness={GlobalNavigationLineOfBusiness.HOTEL}>
    <MyList />
    {/* the Qualtrics experiments below are for different POSes and will not have more than one bucketed in */}
    <AbacusExperiment name="PWA_Qualtrics_Intercept">
      <AbacusControl />
      <AbacusVariant bucket={1}>
        <Qualtrics />
      </AbacusVariant>
    </AbacusExperiment>
    <AbacusExperiment name="PWA_Qualtrics_Intercept_for_BEX_Rest_of_World">
      <AbacusControl />
      <AbacusVariant bucket={1}>
        <Qualtrics />
      </AbacusVariant>
    </AbacusExperiment>
    <AbacusExperiment name="PWA_Qualtrics_Intercept_for_Comet">
      <AbacusControl />
      <AbacusVariant bucket={1}>
        <Qualtrics />
      </AbacusVariant>
    </AbacusExperiment>
  </HeaderBernie>
);
Header.displayName = 'Header';
